import { MiroEmblem } from './components/miro-emblem.esm.js';
import { MiroLogoDark } from './components/miro-logo-dark.esm.js';
import { MiroLogoLight } from './components/miro-logo-light.esm.js';

const MiroLogo = {
    Dark: MiroLogoDark,
    Light: MiroLogoLight,
    Emblem: MiroEmblem
};

export { MiroLogo };
